import React from 'react';

const UserContext = React.createContext({
  notecards:[],
  notes:[]
})

export default UserContext